import React from "react";
import { ValidatorType, ValueType } from "../../types-interfaces/types";

interface RequiredInputProps {
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  onBlur?: React.FocusEventHandler<HTMLInputElement>;
  error?: string;
  value?: ValueType;
}

interface ValidatedInputProps {
  validators?: ValidatorType[];
}

interface ValidatedInputState {
  modified: boolean;
}

function validation<InputProps extends RequiredInputProps>(
  InputComponent: React.ComponentType<InputProps>,
  staticValidators: ValidatorType[] = []
) {
  return class InputWithValidation extends React.Component<
    InputProps & ValidatedInputProps,
    ValidatedInputState
  > {
    state: ValidatedInputState = {
      modified: false
    };

    handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      this.setState({ modified: false });
      if (this.props.onChange) {
        this.props.onChange(e);        
      }
    };

    handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
      this.setState({ modified: true });
      if (this.props.onBlur) {
        this.props.onBlur(e);
      }
    };

    render() {
      const { error, value, validators = [] } = this.props;

      const firstInvalidValidator = [
        ...validators,
        ...staticValidators
      ].find(validate => !!validate(value));

      const validationError =
        this.state.modified && firstInvalidValidator
          ? firstInvalidValidator(value)
          : undefined;

      return (
        <InputComponent
          {...this.props}
          onChange={this.handleChange}
          onBlur={this.handleBlur}
          error={error || validationError}
        />
      );
    }
  };
}

export default validation;
